<template>
  <div class="news-content-container">
    <div class="back-center-panel">
      <div class="back-center" @click="handleJumpPage('OPEN_NEWSCENTER')">
        <div class="back-icon">
          <div class="back-link">返回新闻中心</div>
        </div>
      </div>
    </div>
    <div class="news-content-panel">
      <div class="news-title">一场培训引发的“灵魂拷问”</div>
      <div class="news-date">2022年3月9日</div>
      <div class="news-content">
        <p>先看一则新闻：</p>
        <p>据澎湃新闻等媒体报道，日前，某企业因<strong>举办集中培训活动引发聚集性疫情传播</strong>，再次给我们敲响防疫警钟。</p>
        <p>疫情爆发两年多来，因为<strong>培训聚集</strong>引发的疫情传播早也不是个例。</p>
        <p>培训是企业发展非常重要的一个环节，更是人力资源管理工作的核心模块之一。在“非必要不举办、能线上不线下”的防疫要求下，也引发了一个新的思考：</p>
        <p><strong>传统企业培训还能走多久？</strong></p>
        <p>疫情期间，尽管线上培训、视频会议已经成为新常态，确实也起到了降本增效的作用，但在更深入、更智能的诸如涉及<strong>全周期学习督导、模拟场景演练、多维效果评估、个性引导提升</strong>等方面，广场式的培训效果却不尽如人意，甚至乏善可陈。</p>
        <div class="image-panel">
          <img class="news-image" src="../img/detail/news7_1.jpg" />
        </div>
        <p>而在企业员工越来越年轻化、流动加大的今天，传统的企业培训的效果正在不断下降，甚至越来越容易引起“群众们”吐槽。</p>
        <p>以常见的销售培训为例，<strong>普遍存在人员流动大、培训成本高、转化率低、经验传承难等诸多瓶颈性问题。</strong></p>
        <p>行业通行的“线下集体培训+线上资料学习”模式也存在诸多弊端，如培训过程缺乏监督，培训效果难以量化，而且大多被动接受培训；其次侧重理论学习，缺乏实操演练，新员工、新产品培训周期长，培训成果不能立竿见影。</p>
        <p>这也经常导致做培训工作的讲师、HR们，一边被领导数落，一边被同事抱怨，成为名副其实的受气包。</p>
        <p><strong>那么，人工智能能否破解传统培训的瓶颈问题呢？</strong></p>
        <div class="news-p-title">01 基于AI能力的智能培训机器人</div>
        <p>高效的企业培训，需要的是员工、企业、学习三者整合在一起，推动学习者的提升，完成跨越性的培训与转化，提升企业培训的整体效能与价值，对内增加企业文化的落地，对外呈现在各个合作伙伴与客户面前。</p>
        <p><strong>而想要破解传统企业培训面临的瓶颈问题，数字化转型已是大势所趋。</strong></p>
        <p>深耕技术研发与产业实践多年，腾讯云AI早也练就了敏锐的洞察力，基于传统企业培训痛点和自身领先技术优势，特别推出了<strong>智能培训机器人</strong>的新解决思路，助力企业低成本快培养，破解员工流动大、培训难、效率低、成本高等问题。</p>
        <p>据相关产品经理介绍，<strong>腾讯云AI智能培训机器人是基于语音识别（ASR）、语音合成（TTS）、自然语言理解模型（NLP）与深度学习等AI技术打造的人机对练一体化智能培训平台</strong>，通过完善的智能学习机制，帮助企业快速打造智能、高效、便捷、低成本的企业学堂。</p>
        <p>相较于传统企业培训，智能培训机器人<strong>有更突出的优势！</strong></p>
        <p>
          <p><strong>@人机对练</strong></p>
          <p>传统培训大多进行一次定制，统一培训。智能培训首先改变传统1对多培训方式，为每一位学员提供一对一的金牌培训师。机器人可以模拟客户以及真实业务场景，进行真实的<strong>语音问答/对话演练</strong>，提升员工工作场景能力；针对不同业务场景，不同客户诉求，浓缩优秀员工经验，实战优质话术辅导，生成不同训练任务，批量、快速培养新人上岗。</p>
          <p>陪练设置完成后，还可<strong>反复循环使用，无时间地域限制</strong>，解决异地培训难、重复培训、实战训练成本高等问题。</p>
        </p>
        <p>
          <p><strong>@灵活学习</strong></p>
          <p>传统培训培训地点固定，分公司或外出员工分布在全国各地，很难全部在规定时间到规定地点参加培训，智能培训则不受地点和时间限制，<strong>支持通过PC、APP、H5、小程序等多种渠道接入</strong>，每个学员可根据自己的情况，随时随地进行学习和考试，满足碎片化的学习需要<strong>语音问答/对话演练</strong>，提升员工工作场景能力；针对不同业务场景，不同客户诉求，浓缩优秀员工经验，实战优质话术辅导，生成不同训练任务，批量、快速培养新人上岗。</p>        </p>
        <p>
          <p><strong>@全周期督导</strong></p>
          <p>通过<strong>“学-练-考-评” 闭环</strong>的培训模式，对学员学习、练习和考试的全过程进行评估，并基于话术规范、语速、情绪、服务规范等多维度绘制学员能力画像，构建学员能力模型；针对学员能力短板，还可推荐课程任务，实现个性化学习方案，降低培训成本。<strong>语音问答/对话演练</strong>，提升员工工作场景能力；针对不同业务场景，不同客户诉求，浓缩优秀员工经验，实战优质话术辅导，生成不同训练任务，批量、快速培养新人上岗。</p>
          <div class="image-panel">
            <img class="news-image" src="../img/detail/news7_2.png" />
          </div>
        </p>
        <p>
          <p><strong>@效果评估优化</strong></p>
          <p>AI系统自动记录对练过程，并新人或者老员工进行训练评估，发现共性问题及培训盲点，帮助企业跟踪学员培训效果与薄弱环节，总结个人问题指导员工进行针对性训练，并通过普遍性问题分析来优化对练课程任务设置，培训效果可量化/可追溯 </p>
          <p>其次，是通过计划、执行、检查、行动，PDCA循环模式优化培训方式，驱动培训体系持续升级。</p>
        </p>
        <div class="news-p-title">02 行业应用</div>
        <p>腾讯云AI智能培训机器人广泛适用于<strong>保险、银行、汽车4S店、手机家电、地产、零售</strong>等行业企业内部培训。</p>
        <p><strong>以汽车4S店培训为例，汽车型号规格众多，更新变化快，汽车销售人员的专业水平以及低效的传统培训（以讲师为中心，学员参与度低）直接影响着销售转化率和售后服务收入，使得员工培训一直是企业培训的痛点。</strong></p>
        <p>一方面汽车4S店人员流动大，频繁的新员工入职，须持续占用企业培训部人力资源，影响其业务进展；其次门店人员比较分散，每次集中培训耗费大量时间，培训内容无法数据化，并且效果无法测评，加上疫情叠加影响，导致企业难以组织大面积覆盖的面授培训。</p>
        <p>而在引入智能培训机器人后，以上问题都可以得到针对性解决。</p>
        <div class="image-panel">
          <img class="news-image" src="../img/detail/news7_3.jpg" />
        </div>
        <p>部门或者门店有新员工加入时系统会将新员工与之前上传的新员工<strong>入职培训自动关联</strong>，无需手动下发任务，培训省时省力，员工在线上能自主完成入职培训，快速胜任岗位工作。</p>
        <p>接入在线智能学习平台，通过学习百科管理，打造汽车产品百宝箱（涵盖各汽车型号基础资料、产品学习、成单工具、公司介绍、常见问题、推荐指南等一站式资料库），学员通过电脑和手机端就可以接受学习，不受时间、地点的约束，实现跨区域、跨产品的培训，轻松覆盖全员，大大提高了培训效率，节约培训成本。</p>
        <p>其次，通过“学—练—考”闭环构建多元化线上实训模式，系统全程自动记录评估，量化学员培训效果，并基于汽车销售话术规范、语速、情绪、服务规范等多维度绘制学员能力画像，AI针对性进阶指导。</p>
        <p>事实上，汽车4S店员工培训面临的问题只是众多行业的一个缩影。</p>
        <p>传统企业培训频频引发吐槽，不外乎4个原因：<strong>①培训过程缺乏监督，培训效果难以保证，②培训成果不能立竿见影，③培训本身是否有价值，④不能学以致用，缺乏实践。</strong></p>
        <p><strong>智能培训一方面破解了传统企业培训的瓶颈问题，给企业带来实实在在的降本增效；另一方面，在疫情常态化防控的形势下，也为企业提供了一个可控、可持续的培训选择。</strong></p>
        <p><strong>目前，腾讯云AI智能培训机器人已在保险、银行、汽车4S店、地产等行业成熟应用，有需要的企业客户可通过下方小程序联系了解。</strong></p>
        <div class="news7-contact">
          <div class="contact-info">更多腾讯AI产品免费体验与合作联系</div>
          <div class="contact-info">欢迎识别下方小程序码进入</div>
          <div class="image-panel">
            <img class="qrCode" src="../img/detail/news7_4.png" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import RouteKey from '@/common/RouteKey';
export default {
  name: 'news7',
  methods: {
    handleJumpPage(url, key) {
      url = RouteKey[url];
      if (key != null) {
        this.$router.transfer(url, { key: key });
        return;
      }
      this.$router.transfer(url);
    }
  }
};
</script>

<style lang="less" scoped>
@import "./news.less";
.news-content-container {
  .news-content-panel .news-content{
    .news7-contact {
      margin-top: 30px;
      .contact-info {
        color: #0080FF;
        font-size: 14px;
        text-align: center;
        font-weight: 600px;
        margin: 10px;
      }
      .image-panel {
        margin-bottom: 0;
        .qrCode {
          width: 300px;
          margin-left: 240px;
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/open/panels/news/detail/News7.vue